import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./PaypalWithdrawalReceipt.css";
import logo from "../assets/logo.png";

// Coin icons
import btc from "../assets/btc.png";
import eth from "../assets/eth.png";
import bnb from "../assets/bnb.png";
import sol from "../assets/sol.png";
import xrp from "../assets/xrp.png";
import doge from "../assets/doge.png";
import ltc from "../assets/ltc.png";
import trx from "../assets/trx.png";
import usdt from "../assets/usdt.png";
import usdttether from "../assets/usdttether.png";

const coinIcons = {
  btc,
  eth,
  bnb,
  sol,
  xrp,
  doge,
  ltc,
  trx,
  usdtTron: usdttether,
  usdtBnb: usdt,
};

/* ================= WHATSAPP FLOAT COMPONENT ================= */
const WhatsAppFloat = ({ 
  phoneNumber = "15485825756", 
  message = "Hello! I need urgent support from safepalPay customer service regarding my PayPal withdrawal receipt.",
  position = "right",
  bottom = "30px",
  right = "30px",
  left = "auto",
  size = "54px",
  iconSize = "28px",
  pulseEffect = true,
  className = "",
  style = {}
}) => {
  const formattedNumber = phoneNumber.replace(/[^\d]/g, '');
  const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
  
  const positionStyles = position === "left" 
    ? { left: left || "20px", right: "auto" }
    : { right: right || "20px", left: "auto" };

  const combinedStyles = {
    position: 'fixed',
    bottom: bottom,
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: '#25d366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    zIndex: 10000,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textDecoration: 'none',
    ...positionStyles,
    ...style
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className={`whatsapp-float-unique ${pulseEffect ? 'pulse-unique' : ''} ${className}`}
      style={combinedStyles}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp for withdrawal support"
    >
      <svg 
        width={iconSize} 
        height={iconSize} 
        viewBox="0 0 32 32"
        fill="white"
      >
        <path d="M16.001 3C9.373 3 4 8.373 4 15.001c0 2.645.867 5.084 2.329 7.058L5 29l7.142-1.875A11.96 11.96 0 0016 27c6.627 0 12-5.373 12-11.999C28 8.373 22.627 3 16.001 3zm0 21.999c-1.924 0-3.715-.57-5.219-1.548l-.372-.23-4.242 1.114 1.133-4.135-.242-.384A9.957 9.957 0 016 15.001C6 9.486 10.486 5 16.001 5 21.515 5 26 9.486 26 15.001c0 5.514-4.485 9.998-9.999 9.998zm5.548-7.557c-.303-.151-1.793-.886-2.071-.987-.279-.101-.483-.151-.687.151-.202.302-.787.987-.965 1.19-.177.202-.354.227-.656.075-.303-.151-1.279-.471-2.435-1.5-.9-.802-1.508-1.792-1.686-2.094-.177-.303-.019-.467.133-.619.136-.135.303-.354.455-.531.152-.177.202-.303.303-.505.101-.202.051-.379-.025-.531-.076-.151-.687-1.656-.941-2.269-.247-.592-.498-.512-.687-.521-.177-.008-.379-.01-.582-.01-.202 0-.531.075-.808.379-.278.303-1.06 1.035-1.06 2.524 0 1.488 1.085 2.926 1.237 3.128.151.202 2.14 3.27 5.183 4.588.724.312 1.288.498 1.728.637.726.231 1.387.198 1.911.12.583-.087 1.793-.733 2.047-1.44.253-.707.253-1.313.177-1.44-.076-.126-.278-.198-.581-.354z" />
      </svg>
    </a>
  );
};

const getConfirmationStatusText = (confirmations = []) => {
  const count = confirmations.filter(Boolean).length;
  if (count === confirmations.length) return "Completed";
  return `Pending (${count}/${confirmations.length})`;
};

const PaypalWithdrawalReceipt = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const stored = sessionStorage.getItem("paypalReceipt");
  const initial = state || (stored && JSON.parse(stored)) || {};

  const [receipt, setReceipt] = useState(initial);
  const [loading, setLoading] = useState(true);

  // Crisp Chat Integration
  useEffect(() => {
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = "b5635951-f13a-4b92-95d7-c1e3666f3abf";

    window.$crisp.push(["do", "chat:show"]);

    if (!document.querySelector('script[src="https://client.crisp.chat/l.js"]')) {
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      if (window.$crisp) {
        window.$crisp.push(["do", "chat:hide"]);
      }
    };
  }, []);

  // Pass user email to Crisp when available
  useEffect(() => {
    const userEmail = localStorage.getItem("userEmail");
    const userName = localStorage.getItem("userName");
    
    if (userEmail && window.$crisp) {
      window.$crisp.push(["set", "user:email", userEmail]);
      if (userName) {
        window.$crisp.push(["set", "user:nickname", userName]);
      }
    }
  }, []);

  useEffect(() => {
    if (!receipt.transferId) return;

    const fetchTransfer = async () => {
      try {
        const res = await axios.get(
          `https://backend-safepal.onrender.com/api/transfer/${receipt.transferId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const data = res.data.data;

        setReceipt((prev) => ({
          ...prev,
          asset: data.asset,
          amount: data.amount,
          usdAmount: data.usdAmount,
          status: data.status,
          confirmations: data.confirmations || [
            false,
            false,
            false,
            false,
          ],
        }));

        setLoading(false);
      } catch (err) {
        console.error("Failed to refresh PayPal receipt", err);
        setLoading(false);
      }
    };

    fetchTransfer();
    const interval = setInterval(fetchTransfer, 5000);
    return () => clearInterval(interval);
  }, [receipt.transferId]);

  if (loading || !receipt.transferId) {
    return (
      <div className="pwr-paypal-receipt-page-unique">
        <div className="pwr-paypal-receipt-card-unique">
          <div className="pwr-paypal-receipt-logo-unique">
            <img src={logo} alt="SafepalPay" />
          </div>
          <div className="pwr-loading-container-unique">
            <div className="pwr-loading-spinner-unique"></div>
            <p style={{ textAlign: "center", marginTop: "20px" }}>
              Loading PayPal receipt...
            </p>
          </div>
        </div>
      </div>
    );
  }

  const data = {
    asset: receipt.asset || "btc",
    amount: receipt.amount || 0,
    usdAmount: receipt.usdAmount || 0,
    paypalEmail: receipt.paypalEmail || "—",
    transactionId: receipt.transactionId || "TXN-DEMO-000000",
    status: receipt.status || "processing",
  };

  const confirmations = receipt.confirmations || [
    false,
    false,
    false,
    false,
  ];

  // BANK STYLE STATUS LOGIC
  const isPending = data.status === "processing";
  const isCompleted = data.status === "completed";
  const isFailed = data.status === "failed";

  const normalizedAsset = (() => {
    const asset = String(data.asset).replace(/[-_]/g, "").toLowerCase();
    const map = {
      btc: "btc",
      eth: "eth",
      bnb: "bnb",
      sol: "sol",
      xrp: "xrp",
      doge: "doge",
      ltc: "ltc",
      trx: "trx",
      usdttron: "usdtTron",
      usdttrc20: "usdtTron",
      usdtbnb: "usdtBnb",
      usdtbep20: "usdtBnb",
    };
    return map[asset] || asset;
  })();

  const assetDisplayName =
    normalizedAsset === "usdtTron" || normalizedAsset === "usdtBnb"
      ? "USDT"
      : normalizedAsset.toUpperCase();

  const icon = coinIcons[normalizedAsset];

  // Function to handle print receipt
  const handlePrint = () => {
    window.print();
  };

  // Function to share receipt
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Withdrawal Receipt - SafepalPay',
        text: `Your PayPal withdrawal of $${Number(data.usdAmount).toFixed(2)} has been ${isCompleted ? 'approved' : isPending ? 'processed' : 'updated'}. Transaction ID: ${data.transactionId}`,
        url: window.location.href,
      }).catch(() => {
        alert("Share cancelled or failed");
      });
    } else {
      alert("Share not supported on this browser");
    }
  };

  return (
    <>
      <div className="pwr-paypal-receipt-page-unique">
        <div className="pwr-paypal-receipt-card-unique">
          <div className="pwr-paypal-receipt-logo-unique">
            <img src={logo} alt="SafepalPay" />
          </div>

          <h2 className="pwr-paypal-receipt-title-unique">Withdrawal Receipt</h2>

          {/* BANK STYLE STATUS ROW */}
          <div
            className={`pwr-paypal-receipt-row-unique pwr-transaction-status-unique ${
              isPending ? "pwr-pending-unique" : isCompleted ? "pwr-completed-unique" : "pwr-failed-unique"
            }`}
          >
            <span>Status</span>
            <strong>
              {isPending && "Pending"}
              {isCompleted && "Approved"}
              {isFailed && "Rejected"}
            </strong>
          </div>

          {/* CONFIRMATIONS ONLY IF PROCESSING */}
          {isPending && (
            <div className="pwr-paypal-receipt-row-unique">
              <span>Confirmations</span>
              <div className="pwr-confirmation-visual-unique">
                {confirmations.map((confirmed, i) => (
                  <div
                    key={i}
                    className={`pwr-confirmation-dot-unique ${
                      confirmed ? "pwr-confirmed-unique" : "pwr-pending-unique"
                    }`}
                  >
                    {i + 1}
                  </div>
                ))}
              </div>
              <small className="pwr-confirmation-text-unique">
                {getConfirmationStatusText(confirmations)}
              </small>
            </div>
          )}

          <div className="pwr-paypal-receipt-row-unique">
            <span>Transaction ID</span>
            <strong>{data.transactionId}</strong>
          </div>

          <div className="pwr-paypal-receipt-row-unique">
            <span>PayPal Email</span>
            <strong>{data.paypalEmail}</strong>
          </div>

          <div className="pwr-paypal-receipt-row-unique">
            <span>Asset</span>
            <div className="pwr-paypal-receipt-asset-unique">
              {icon && <img src={icon} alt={assetDisplayName} />}
              <strong>{assetDisplayName}</strong>
            </div>
          </div>

          <div className="pwr-paypal-receipt-row-unique">
            <span>Crypto Amount</span>
            <strong>{Number(data.amount).toFixed(8)}</strong>
          </div>

          <div className="pwr-paypal-receipt-row-unique">
            <span>USD Value</span>
            <strong>${Number(data.usdAmount).toFixed(2)}</strong>
          </div>

          <div className="pwr-paypal-receipt-footer-unique">
            <p>
              {isPending &&
                "Your PayPal withdrawal is being processed. Please allow up to 24 hours for completion."}
              {isCompleted &&
                "Your withdrawal has been successfully approved and processed. The funds have been sent to your PayPal account."}
              {isFailed &&
                "Your withdrawal request has been rejected. Please contact support for more information."}
            </p>

            <div className="pwr-paypal-receipt-buttons-unique">
              <button
                className="pwr-paypal-receipt-btn-unique pwr-print-btn-unique"
                onClick={handlePrint}
              >
                🖨️ Print Receipt
              </button>
              
              <button
                className="pwr-paypal-receipt-btn-unique pwr-share-btn-unique"
                onClick={handleShare}
              >
                📤 Share Receipt
              </button>
              
              <button
                className="pwr-paypal-receipt-btn-unique pwr-dashboard-btn-unique"
                onClick={() => navigate("/dashboard")}
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Float Button - For Withdrawal Support */}
      <WhatsAppFloat 
        phoneNumber="15485825756"
        message="Hello! I need urgent support from safepalPay customer service regarding my PayPal withdrawal receipt."
        position="right"
        bottom="30px"
        right="30px"
        pulseEffect={true}
        size="54px"
        iconSize="28px"
      />
    </>
  );
};

export default PaypalWithdrawalReceipt;